import { CALENDAR_GRID_MODES_ALL } from '../../../constants/calendarGrid'
import { getQaSelector } from '../../../utils/common'
import { Skeleton } from '../../Skeleton'
import { useCalendarPreferences } from '../Calendar.hooks'
import { CalendarRail } from '../CalendarRail'
import { CalendarView } from '../CalendarView'

import { QA_NAME_CALENDAR_SECTION } from './CalendarSection.constants'
import { getCalendarSectionFilters } from './CalendarSection.utils'

import * as styles from './CalendarSection.module.css'

function CalendarSection() {
  const { handleChangePreferences, isLoading, preferences } =
    useCalendarPreferences()

  function handleChangeMode(viewMode) {
    handleChangePreferences({ view_mode: viewMode })
  }

  return isLoading ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_SECTION })}
      className={styles.CalendarSection}
    >
      <CalendarRail
        preferences={preferences}
        onChange={handleChangePreferences}
      />
      <CalendarView
        className={styles.view}
        filters={getCalendarSectionFilters(preferences)}
        initialMode={preferences.view_mode}
        modes={CALENDAR_GRID_MODES_ALL}
        onChangeMode={handleChangeMode}
      />
    </div>
  )
}

export default CalendarSection
